import React from "react";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";
import { Grid, Link } from "@mui/material";
import { Controller } from "react-hook-form";
import { useStyles } from "../login/Login.page.style";

const ForgotpswEmailComponent = (props) => {
    const { register, handleSubmit, onSubmit, control, errors } = props;
    const classes = useStyles();
    return (
        <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <Grid container direction={"column"} className={classes.loginFormContainer}>
                <Grid item style={{ lineHeight: 1.1 }}>
                    <div className={classes.welcomeFont}>Welcome to EHP</div>
                    <div className={classes.welcomeFont}>
                        Data Collaboration Laboratory Portal {process.env.REACT_APP_ENV_DESC || ""}
                    </div>
                </Grid>
                <Grid item container direction={"column"} className={classes.loginInputBox}>
                    <Grid item className={classes.loginFont}>
                        FORGET PASSWORD
                    </Grid>
                    <Grid item>Enter your email address and we will send you instructions to reset your password.</Grid>
                    <Grid item className={classes.LoginInputWrapper}>
                        <FormControl fullWidth>
                            <FormLabel htmlFor="email" className={classes.blackColor}>
                                Email
                            </FormLabel>
                            <Controller
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        {...register("email")}
                                        error={!!errors?.email}
                                        helperText={errors?.email?.message}
                                        variant="standard"
                                        InputProps={{
                                            className: classes.inputStyle,
                                        }}
                                        inputProps={{ maxLength: 128 }}
                                    />
                                )}
                                id={"email"}
                                name="email"
                                control={control}
                                rules={{
                                    required: true,
                                }}
                                fullWidth={true}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item className={classes.LoginInputWrapper}>
                        <FormControl>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                style={{
                                    textTransform: "none",
                                    fontFamily: "Quicksand-SemiBold",
                                    fontSize: 16,
                                }}
                            >
                                Send
                            </Button>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item container className={classes.signupNow}>
                    <Link href={"/login"} className={classes.signupLink}>
                        Back to login
                    </Link>
                </Grid>
            </Grid>
        </form>
    );
};

export default ForgotpswEmailComponent;
